import React from "react";
import { IconButton, LinearProgress, Paper, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import DataTable from "react-data-table-component";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { Link } from "react-router-dom";

const sortIcon = <ArrowDownward />;

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
    table: {
      minWidth: 650,
    },
  },
  btn: {
    margin: theme.spacing(4)
  }
}));

const BannerList = ({
  giftsList,
  editBanner,
  setOpen,
  open,
  handleClose,
  deleteGifts,
  check,
  singleGiftsById,
}) => {
  const classes = useStyles();

  // const heading = [
  //   {
  //     name: "Sr. No",
  //     wrap: true,
  //     sortable: true,
  //     cell: (row, index) => index + 1,
  //   },
  //   {
  //     name: "Banner Type",
  //     selector: "type",
  //     wrap: true,
  //     sortable: true,
  //   },
  //   {
  //     name: "Image",
  //     selector: "image",
  //     wrap: true,
  //     sortable: true,
  //     cell: (giftsList) => (
  //       <div>
  //         <img
  //           style={{ height: "60px", width: "60px" }}
  //           src={giftsList.image}
  //           alt="img"
  //         />
  //       </div>
  //     ),
  //   },
  //   {
  //     name: "Action",
  //     wrap: true,
  //     center: true,

  //     cell: (giftsList) => (
  //       <div>
  //         <Link to={"/dashboard/create-banner/" + giftsList._id}>
  //           <IconButton
  //             edge="end"
  //             aria-label="edit"
  //             // onClick={() => {
  //             //     singleGiftsById(giftsList._id);
  //             // }}
  //           >
  //             <EditIcon color="primary" />
  //           </IconButton>
  //         </Link>

  //         {/* <IconButton
  //           edge="end"
  //           aria-label="delete"
  //           onClick={() => {
  //             deleteGifts(giftsList._id);
  //           }}
  //         >
  //           <DeleteIcon color="primary" />
  //         </IconButton> */}
  //       </div>
  //     ),
  //   },
  // ];

  const heading = [
    {
      name: "Sr. No",
      wrap: true,
      sortable: true,
      cell: (row, index) => <div>{typeof index === "number" ? index + 1 : "-"}</div>,
    },
    {
      name: "Banner Type",
      selector: (row) => row.type ?? "-",
      wrap: true,
      sortable: true,
    },
    {
      name: "Image",
      selector: (row) => row.image ?? "",
      wrap: true,
      sortable: false,
      cell: (row) => (
        <div>
          <img
            style={{ height: "60px", width: "60px", objectFit: "cover" }}
            src={row.image}
            alt={row.type || "banner"}
            onError={(e) => (e.currentTarget.style.display = "none")}
          />
        </div>
      ),
    },
    {
      name: "Action",
      wrap: true,
      center: true,
      cell: (row) => (
        <div>
          <Link to={`/dashboard/create-banner/${row._id}`}>
            <IconButton edge="end" aria-label="edit">
              <EditIcon color="primary" />
            </IconButton>
          </Link>
          {/* <IconButton
            edge="end"
            aria-label="delete"
            onClick={() => {
              deleteGifts(row._id);
            }}
          >
            <DeleteIcon color="primary" />
          </IconButton>  */}
        </div>
      ),
    },
  ];

  console.log('giftsList', giftsList)
  return (
    <div>
      {!giftsList ? (
        <LinearProgress color="primary" />
      ) : (
        <Paper className={classes.paper} square>
          {check ? (
            <>
              {/* <Link to="/dashboard/create-banner">
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.btn}
                >
                  Add Banner
                </Button>
              </Link> */}
              <DataTable
                columns={heading}
                noHeader={true}
                data={Array.isArray(giftsList) ? giftsList : giftsList ? [giftsList] : []} // <-- ensure an array
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                sortIcon={sortIcon || undefined} // ensure sortIcon is valid or undefined
                striped={true}
                highlightOnHover={true}
                responsive={true}
              />
            </>
          ) : (
            ""
          )}
        </Paper>
      )}
    </div>
  );
};

export default BannerList;
